import { initializeModalFunctionality } from "./module/VideoModalFunctions"

document.addEventListener('DOMContentLoaded', () => {
  const movieNodeList = document.querySelectorAll('[data-role="movie-thumbnail"]')
  const movieModals = document.querySelectorAll('.movie__modal')
  initializeModalFunctionality(movieNodeList, movieModals)
})
